<div class="background-container-landing">
    <div class="background-landing">
        <mat-toolbar color="primary" class="toolbar-landing">
            <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo" />
        </mat-toolbar>

        <div class="main-landing">
            <div class="main-inner-landing">

                <div class="title-page">High Limits Disability Insurance</div>
                <div class="sub-text">
                    Increased protection that supplements existing coverage up to 70% income replacement
                </div>
                <div class="button-area">
                    <button class="main-inner-landing button-mgis large-button" (click)="findApplication()" mat-flat-button>Get Your
                        Quote</button>
                </div>
            </div>

            <div class="main-inner-footer">
                <div class="main-inner-faq">
                    <button class="faq-item" mat-raised-button (click)="whatIsHLD()">What is High Limits Disability Insurance?</button>
                    <button class="faq-item" mat-raised-button (click)="defineHLD()">How is Disability defined?</button>
                    <button class="faq-item" mat-raised-button (click)="openFAQ()">Other Frequently Asked Questions</button>
                </div>
                <br />
                <footer class="main-footer-landing">
                    <div class="footer-inner">
                        <div class="footer-image">
                            <img src="../assets/img/mgis/logo_small.png" alt="MGIS Logo" class="logo2" />
                        </div>
                        <div class="footer-details">
                            MGIS is a leading national insurance program manager experienced in building and managing specialized insurance programs for doctors. We partner with highly rated insurers and focus on disability and life insurance for practices of all sizes, types, and medical specialties. Insurance policies managed by MGIS are backed by members of the underwriting companies of Reliance Matrix. We work exclusively through select brokers and insurance advisers. MGIS services are provided by MGIS affiliated companies: The MGIS Companies, Inc., Medical Group Insurance Services, Inc., and MGIS Underwriting Managers, Inc. (DBA as MGIS Professional Insurance Solutions in CA and MGIS Underwriting Agency in NY). 
                        </div>
                    </div>
                    <br />
                    <div class="footer-inner">
                        <div class="footer-image">
                            <img src="../assets/img/mgis/lloyds_logo.png" alt="Lloyds Logo" class="lloyd-logo" />
                        </div>
                        <div class="footer-details">
                            Lloyd’s is the world’s leading insurance and reinsurance marketplace. Through the collective intelligence and risk-sharing expertise of the market’s underwriters and brokers, Lloyd’s helps to create a braver world. The Lloyd’s market provides the leadership and insight to anticipate and understand risk, and the knowledge to develop relevant, new and innovative forms of insurance for customers globally. It offers the efficiencies of shared resources and services in a marketplace that covers and shares risks from more than 200 territories, in any industry, at any scale. And it promises a trusted, enduring partnership built on the confidence that Lloyd’s protects what matters most: helping people, businesses and communities to recover in times of need. Lloyd’s began with a few courageous entrepreneurs in a coffeeshop. Three centuries later, the Lloyd’s market continues that proud tradition, sharing risk in order to protect, build resilience and inspire courage everywhere. 
                        </div>
                    </div>

                </footer>
                <div>
                     
                </div>
            </div>
        </div>